import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { HelpMenuComponent, PromoPopoverComponent } from '@mode/accounts/ui';

export const DowngradedAccountsUIModule = angular
  .module('downgraded-accounts-ui', [])
  .directive('modeHelpMenu', downgradeComponent({ component: HelpMenuComponent }))
  .directive('modePromoPopover', downgradeComponent({ component: PromoPopoverComponent })).name;
